import {
  VERIFY_OTP,
  VERIFY_OTP_SUCCESSFUL,
  VERIFY_OTP_FAILED,
  SEND_MOBILE,
  SEND_MOBILE_SUCCESSFUL,
  SEND_MOBILE_FAILED,
  RESET_VERIFYOTP_ERRORS,
  SEND_FORGETPASSMOBILENO,
  SEND_FORGETPASSMOBILENO_SUCCESSFUL,
  SEND_FORGETPASSMOBILENO_FAILED,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_SUCCESSFUL,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_RESET,
  CHANGE_PROFILE_PASSWORD_START,
  CHANGE_PROFILE_PASSWORD_SUCCESSFUL,
  CHANGE_PROFILE_PASSWORD_FAILED,
  CHANGE_PROFILE_PASSWORD_RESET,
} from "./actionTypes"

export const verifyOtp = payload => {
  return {
    type: VERIFY_OTP,
    payload,
  }
}

export const verifyOtpSuccessful = payload => {
  return {
    type: VERIFY_OTP_SUCCESSFUL,
    payload,
  }
}

export const verifyOtpFailed = payload => {
  return {
    type: VERIFY_OTP_FAILED,
    payload,
  }
}

export const sendMobile = number => {
  // console.log(number)
  return {
    type: SEND_MOBILE,
    payload: number,
  }
}

export const sendMobileSuccessful = payload => {
  return {
    type: SEND_MOBILE_SUCCESSFUL,
    payload,
  }
}

export const sendMobileFailed = payload => {
  return {
    type: SEND_MOBILE_FAILED,
    payload,
  }
}

export const verifyOtpErrorReset = () => {
  return {
    type: RESET_VERIFYOTP_ERRORS,
  }
}


export const sendForgetPassmobno = number => {
  // console.log(number)
  return {
    type: SEND_FORGETPASSMOBILENO,
    payload: number,
  }
}

export const sendForgetPassmobnoSuccessful = payload => {
  return {
    type: SEND_FORGETPASSMOBILENO_SUCCESSFUL,
    payload,
  }
}

export const sendForgetPassmobnoFailed = payload => {
  return {
    type: SEND_FORGETPASSMOBILENO_FAILED,
    payload,
  }
}



export const ChangePasswordStart = payload => {
  return {
    type: CHANGE_PASSWORD_START,
    payload,
  }
}

export const ChangePasswordSuccess = payload => {
  return {
    type: CHANGE_PASSWORD_SUCCESSFUL,
    payload,
  }
}

export const ChangePasswordFailure = error => {
  return {
    type: CHANGE_PASSWORD_FAILED,
    error,
  }
}
export const ChangePasswordReset = () => {
  return {
    type: CHANGE_PASSWORD_RESET,
  }
}


export const ChangeProfilePasswordStart = payload => {
  return {
    type: CHANGE_PROFILE_PASSWORD_START,
    payload,
  }
}

export const ChangeProfilePasswordSuccess = payload => {
  return {
    type: CHANGE_PROFILE_PASSWORD_SUCCESSFUL,
    payload,
  }
}

export const ChangeProfilePasswordFailure = error => {
  return {
    type: CHANGE_PROFILE_PASSWORD_FAILED,
    error,
  }
}
export const ChangeProfilePasswordReset = () => {
  return {
    type: CHANGE_PROFILE_PASSWORD_RESET,
  }
}


